import { 
	ADD_CATEGORY_FEATURE,
	SET_CATEGORY_FEATURES,
	UPDATE_CATEGORY_FEATURE,
	SET_ACTIVE_CATEGORY_FEATURE,
	SET_FILE_LIST,
	SET_CLASS_NAME,
	SET_STYLE_SHEET,
	SET_CATEGORY,
	DELETE_CATEGORY_FEATURE,
	SET_BRANDS,
	SET_NAME,
	SET_ORDER,
	UPDATE_CATEGORY_FEATURE_VALUE,
	TOGGLE_CATEGORY_FEATURE_ACTIVE
} from './types';

import {
	_getCategoryFeature,
	_getCategoryFeatures,
	_postCategoryFeature, 
	_postEditCategoryFeature,
	_postUpdateCategoryFeature,
	_deleteCategoryFeature,
	_postToggleCategoryFeatureActive
} from '../../../services'

export const addCategoryFeature = () => {
	return {
		type: ADD_CATEGORY_FEATURE,
		payload: _postCategoryFeature()
	}
}

export const setCategoryFeatures = (inputObj) => {
	return {
		type: SET_CATEGORY_FEATURES,
		payload: _getCategoryFeatures(inputObj)
	}
}

export const updateCategoryFeature = (categoryFeature) => {
	return {
		type: UPDATE_CATEGORY_FEATURE,
		payload: _postEditCategoryFeature(categoryFeature)
	}
}

export const setActiveCategoryFeature = (categoryFeatureId) => {
	return {
		type: SET_ACTIVE_CATEGORY_FEATURE,
		payload: _getCategoryFeature({ categoryFeatureId })
	}
}

export const setFileList = (fileList) => {
	return {
		type: SET_FILE_LIST,
		fileList
	}
}

export const setClassName = ({ fileId, className }) => {
	return {
		type: SET_CLASS_NAME,
		fileId,
		className
	}
}

export const setStyleSheet = (styleSheet) => {
	return {
		type: SET_STYLE_SHEET,
		styleSheet
	}
}

export const setCategory = ({fileId, category}) => {
	return {
		type: SET_CATEGORY,
		fileId,
		category
	}
}

export const deleteCategoryFeature = (categoryFeatureId) => {
	return {
		type: DELETE_CATEGORY_FEATURE,
		payload: _deleteCategoryFeature(categoryFeatureId)
	}
}

export const setBrands = (brands) => {
	return {
		type: SET_BRANDS,
		brands
	}
}

export const setName = (name) => {
	return {
		type: SET_NAME,
		name
	}
}

export const setOrder = ({fileId, order}) => {
	return {
		type: SET_ORDER,
		fileId,
		order
	}
}

export const updateCategoryFeatureValue = ({ categoryFeatureId, key, value }) => {
	return {
		type: UPDATE_CATEGORY_FEATURE_VALUE,
		payload: _postUpdateCategoryFeature({
			categoryFeatureId,
			key,
			value
		})
	}
}

export const toggleCategoryFeatureActive = (categoryFeatureId) => {
	return {
		type: TOGGLE_CATEGORY_FEATURE_ACTIVE,
		payload: _postToggleCategoryFeatureActive({
			categoryFeatureId
		})
	}
}


// WEBPACK FOOTER //
// ./src/components/category-feature/actions/index.js